// extracted by mini-css-extract-plugin
export default {"listContainer":"SOSContactList_listContainer__uJEyZ"};